import React from "react";
import { SlidePages } from "../../components/slidePages";
import { ServicesListe } from "../../components/servicesListe";
import { Intervention } from "../../components/serviceDetails/intervention";

export const ServicesPage = () => {
  return (
    <div>
      {" "}
      <SlidePages
        title={"Services de rénovation énergétique"}
        description={
          "Chez Habitat IDF, nous proposons une gamme complète de services de rénovation énergétique pour optimiser la performance de votre logement, valoriser votre patrimoine et réduire vos factures."
        }
      />
      <ServicesListe />
    </div>
  );
};
